import React, { useRef } from "react";
import styled ,{keyframes}from "styled-components";
import { PieChart } from "react-minimal-pie-chart";
const CardGraphicC = styled.div`
  background: rgba(196, 196, 196, 0.38);
  border-radius: 9.03012px;
  width: 270.9px;
  display: flex;
  margin-top:1em;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: auto;
  min-height: 413.13px;
  padding-top: 10px;
  gap: 1em;
  .card-title {
    width: 100%;
    padding-left: 3em;
    h2 {
      width: 80%;
      margin: 0;
      color: #fff;
      font-family: nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 18.0602px;
      line-height: 27px;
    }
    .card-titleA {
      font-weight: bold;
    }
  }

  .data {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;
    margin-top:1em;
    flex-direction: column;
    .pie {
      width: 90%;
    }
    .data-graphic {
      position: relative;
    }
    .data-info {
      width: 90%;
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      column-gap: 10px;
      margin-top:8px;
      row-gap: 8px;
    }
  }
`;


const DataGraphi = styled.span`
  font-family: nunito;
 
  font-weight: 700;
  font-size: 13.5452px;
  line-height: 18px;
  position: relative;

  display: flex;
  text-transform: capitalize;
  align-items: center;
  justify-content: center;
  margin-left:2px;
  column-gap: 2px;

  :before {
    content: " ";
    background-color: ${(prosp) => prosp.colorBack};
    width: 14px;
    height: 14px;

    border-radius: 50%;
  }
`;
function CardGraphic({ data, title }) {
  console.log(data);
  return (
    <CardGraphicC>
      <div className="card-title">
        <h2>{title[0]}</h2>
        <h2 className="card-titleA">{title[1]}</h2>
      </div>
      <div className="data">
        <PieChart  data={data} className="pie"
        animate={true}
        animationDuration={2500}
        />
        <div className="data-info">
          {data.map((e,index=0) => (
            <DataGraphi key={index} colorBack={e.color}>{e.title}</DataGraphi>
          ))}
        </div>
      </div>
    </CardGraphicC>
  );
}

export default CardGraphic;
